var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInvoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 223310"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Paper Plus",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Fill 3",
  d: "M42.022 17.552c-1.129 0-2.624-.025-4.485-.025a8.341 8.341 0 0 1-8.273-8.34V1.148A1.141 1.141 0 0 0 28.133 0H14.909A11.223 11.223 0 0 0 3.75 11.272V38.21A11.731 11.731 0 0 0 15.424 50h19.689A11.19 11.19 0 0 0 46.25 38.755V18.677a1.134 1.134 0 0 0-1.134-1.145c-1.055.007-2.324.02-3.094.02",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Fill 1",
  d: "M35.211 1.419a1.193 1.193 0 0 0-2.053.831v6.6a5.066 5.066 0 0 0 5.04 5.04c1.745.02 4.165.025 6.22.02a1.192 1.192 0 0 0 .858-2.02c-2.638-2.746-7.36-7.661-10.065-10.471",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Fill 6",
  d: "M30.918 25.591h-4.32v-4.318a1.861 1.861 0 1 0-3.722 0v4.318h-4.318a1.863 1.863 0 0 0 0 3.725h4.317v4.315a1.861 1.861 0 1 0 3.722 0v-4.32h4.32a1.863 1.863 0 1 0 0-3.725"
})))));
export default SvgInvoice;